import Router from 'vue-router';
import login from './login';
import todos from './todos';
import projects from './projects';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				redirect: '/projects',
				children: [todos, projects],
				component: () => import('@/pages/page-home'),
				meta: {
					title: 'Home',
				},
			},
			login,
		],
	});
	config.beforeEach((to, from, next) => {
		if (to.name !== 'login') {
			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token) {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js